import { BlockMath, InlineMath } from 'react-katex';

type KatexFormulaProps = {
  latex: string;
  display?: 'block' | 'inline';
};

export default function KatexFormula({ latex, display = 'block' }: KatexFormulaProps) {
  const MathComponent = display === 'inline' ? InlineMath : BlockMath;
  const className = display === 'inline' ? 'aida-msg__math aida-msg__math--inline' : 'aida-msg__math';

  const Wrapper = display === 'inline' ? 'span' : 'div';

  return (
    <Wrapper className={className}>
      <MathComponent
        math={latex}
        renderError={() => (
          <code className="aida-msg__math--error" aria-label="Formula no renderizable">
            {display === 'block' ? `[ ${latex} ]` : `$${latex}$`}
          </code>
        )}
        errorColor="#b42318"
      />
    </Wrapper>
  );
}
